import { Component } from '@angular/core';

@Component({
  selector: 'app-existing-submission-banner',
  templateUrl: './existing-submission-banner.component.html',
  styleUrls: ['./existing-submission-banner.component.scss']
})
export class ExistingSubmissionBannerComponent {}
